import React, { Component } from 'react';
import IdleTimer from 'react-idle-timer';

import { millisToMinutesAndSeconds } from '../../utils/date';

import './popup.scss';

export default class CaseCreateModal extends Component {
	constructor(props) {
		super(props);
		this.idleTimer = null;
		this.handleOnIdle = this.handleOnIdle.bind(this);
		this.state = {
			remaining: 1000 * 60 * 5,
		};
	}

	componentDidMount() {
		setInterval(() => {
			if (this.idleTimer) {
				this.setState({
					remaining: this.idleTimer.getRemainingTime(),
				});
			}
		}, 1000);
	}

	render() {
		let onboardClass = 'popup popup--active';
		if (!this.props.show) {
			return null;
		}

		return (
			<div className={onboardClass} onClick={null}>
				<IdleTimer
					ref={ref => { this.idleTimer = ref; }}
					timeout={1000 * 60 * 5}
					onIdle={this.handleOnIdle}
					debounce={250}
					events={[]}
				/>
				<div className='popup__content span6 popup__container' onClick={(e) => { e.stopPropagation(); }}>
					<h4>Inactivity notifier</h4>
					<div className="popup__seperator" />
					<p className="popup__text">You will be automatically redirected in {millisToMinutesAndSeconds(this.state.remaining)}</p>
					<div className="popup__actions">
						<span
							className="popup__alternative"
							onClick={() => {
								this.props.handleInactive();
							}}
						>Log out now</span>
						<button
							className='button button--dark'
							onClick={() => {
								this.props.handleClose();
							}}
						>
							Stay logged in
						</button>
					</div>
				</div>
			</div>
		);
	}

	handleOnIdle(event) {
		this.props.handleInactive();
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/popup.js
 **/